import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-12 bg-aged-cream-green relative overflow-hidden" data-id="element-225">
      {/* Decorative background - removed gray gradient */}

      <div className="container mx-auto px-4 relative z-10" data-id="element-226">
        <div className="max-w-4xl mx-auto" data-id="element-227">
          <div className="text-center mb-16" data-id="element-228">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-229">
              No es que gastes mal
            </motion.h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-230">
              No es que seas desordenada. Y definitivamente no es que "no sirvas
              para el dinero".
            </p>
          </div>

          <div className="mb-12 text-center" data-id="element-231">
            <p className="text-xl text-slate-700 font-medium" data-id="element-232">
              Tú creciste escuchando frases como:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16" data-id="element-233">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="space-y-6" data-id="element-234">
              <div className="bg-aged-green p-6 rounded-xl shadow-sm border-l-4 border-[#f4c430] overflow-hidden" data-id="element-235">
                <p className="text-lg text-white italic relative z-10" data-id="element-236">
                  "Hay que ahorrar."
                </p>
              </div>
              <div className="bg-aged-green p-6 rounded-xl shadow-sm border-l-4 border-[#f4c430] overflow-hidden" data-id="element-237">
                <p className="text-lg text-white italic relative z-10" data-id="element-238">
                  "No gastes tanto."
                </p>
              </div>
              <div className="bg-aged-green p-6 rounded-xl shadow-sm border-l-4 border-[#f4c430] overflow-hidden" data-id="element-239">
                <p className="text-lg text-white italic relative z-10" data-id="element-240">
                  "El dinero no crece en los árboles."
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="relative" data-id="element-241">
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-yellow rounded-full mix-blend-multiply opacity-20 blur-2xl" data-id="element-242" />
              <div className="bg-white p-8 rounded-2xl shadow-xl relative z-10" data-id="element-243">
                <p className="text-slate-600 mb-4 leading-relaxed" data-id="element-244">
                  Pero nadie te explicó cómo manejar el dinero en la vida real.
                </p>
                <p className="text-slate-600 leading-relaxed" data-id="element-245">
                  Nadie te enseñó qué hacer cuando cobras por quincena. Cuando
                  los gastos no son iguales cada mes. Cuando hay hijos, antojos,
                  imprevistos y cansancio emocional.
                </p>
                <p className="text-slate-600 mt-4 leading-relaxed" data-id="element-246">
                  Así que hiciste lo que pudiste.
                </p>
              </div>
            </motion.div>
          </div>

          {/* Buscaste ayuda section */}
          <div className="mb-12" data-id="element-247">
            <h3 className="text-3xl font-bold text-slate-900 text-center mb-4" data-id="element-248">
              Buscaste ayuda.
            </h3>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="border-2 border-[#1a3d3d] p-1 rounded-2xl shadow-xl" data-id="element-249">
            <div className="bg-white rounded-[14px] p-8 md:p-12" data-id="element-250">
              <div className="w-16 h-16 bg-[#1a3d3d] text-[#f4c430] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-251">
                <XCircle size={32} strokeWidth={2.5} data-id="element-252" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-8 text-center" data-id="element-253">
                Lo intentaste todo… y aun así estás cansada
              </h3>

              <div className="space-y-6 max-w-3xl mx-auto mb-8" data-id="element-254">
                <div className="bg-aged-green p-6 rounded-xl border-l-4 border-[#f4c430] overflow-hidden" data-id="element-255">
                  <p className="text-white relative z-10" data-id="element-256">
                    <span className="font-bold" data-id="element-257">
                      Probaste apps de presupuesto.
                    </span>{' '}
                    Bonitas, llenas de gráficas… imposibles de mantener.
                  </p>
                </div>
                <div className="bg-aged-green p-6 rounded-xl border-l-4 border-[#f4c430] overflow-hidden" data-id="element-258">
                  <p className="text-white relative z-10" data-id="element-259">
                    <span className="font-bold" data-id="element-260">
                      Intentaste presupuestos "perfectos".
                    </span>{' '}
                    Que solo funcionan en meses ideales que casi nunca existen.
                  </p>
                </div>
                <div className="bg-aged-green p-6 rounded-xl border-l-4 border-[#f4c430] overflow-hidden" data-id="element-261">
                  <p className="text-white relative z-10" data-id="element-262">
                    <span className="font-bold" data-id="element-263">
                      Hiciste retos de ahorro extremos.
                    </span>{' '}
                    Que duran lo que dura la motivación.
                  </p>
                </div>
              </div>

              <div className="space-y-4 text-center max-w-2xl mx-auto" data-id="element-264">
                <p className="text-lg text-slate-600" data-id="element-265">
                  Guardaste videos en TikTok. Sobres. Retos. Trucos.
                </p>
                <p className="text-lg text-slate-600" data-id="element-266">
                  Te emocionaste. Y luego volviste a lo mismo.
                </p>
                <p className="text-lg text-slate-700 font-medium" data-id="element-267">
                  No porque no quieras cambiar. Sino porque ninguna de esas
                  soluciones está pensada para tu realidad.
                </p>
                <p className="text-2xl font-bold text-[#f4c430] mt-6" data-id="element-268">
                  Y eso cansa.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Lo que más duele section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-16 text-center max-w-2xl mx-auto" data-id="element-269">
            <p className="text-xl text-slate-600 mb-6" data-id="element-270">
              Cansa intentarlo una y otra vez. Cansa sentir culpa por gastar.
              Cansa vivir con ansiedad cada quincena.
            </p>
            <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6" data-id="element-271">
              Lo que más duele no es el dinero.
            </h3>
            <p className="text-xl text-slate-600" data-id="element-272">
              Es la sensación de no tener control. De vivir siempre al filo. De
              preguntarte si así va a ser siempre.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}